// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__7Vi1S","left":"Virtual_left__ega6Y","wrapper":"Virtual_wrapper__cNZ5f"};